<template>
  <div class="real-estate">
    <section class="hero">
      <h1>
        Become an <br />
        Electrify America Site Host
      </h1>
      <p>and join the largest open Hyper-Fast charging network in the U.S.</p>
      <section class="flex">
        <p>We are the largest open Hyper-Fast charging network in the U.S. &mdash; with speeds up to 350 kW.</p>
        <p>Attract new customers and revenue opportunities</p>
      </section>
      <a href="#real-estate-form" class="button">request to host a Hyper-Fast charging station</a>
    </section>
    <section class="body text">
      <div class="">
        <div class="lede lede--reverse">
          <div class="column image">
            <img
              loading="lazy"
              alt="Electrify America charging station with person using their mobile phone to set up their charging session"
              src="@/assets/images/RealEstate/person-using-charger.png"
            />
          </div>
          <div class="column">
            <h2>Site Host Benefits</h2>
            <p>
              Becoming a site host allows you to attract new customers and puts you at the forefront of the continually
              changing consumer landscape.
            </p>
            <ul class="list-electric-charger">
              <li><strong>18.7 million </strong>EVs are projected to be on U.S. roads by 2030.</li>
              <li>
                <strong>81% </strong>of EV owners report that the availability of a charger makes them more loyal to a
                business.
              </li>
              <li><strong>Diversify </strong>amenities available at your retail property.</li>
              <li><strong>Monetize </strong>your property in previously untapped ways.</li>
              <li><strong>Capitalize </strong>on relationships with OEMs by driving EVs of all kinds to your site.</li>
            </ul>
          </div>
        </div>
        <div class="cards-container">
          <h2>Optimal Site Criteria</h2>
          <section class="l-three-col">
            <div class="card">
              <img
                loading="lazy"
                src="@/assets/images/RealEstate/electric-business.svg?external"
                alt="icon displaying business and car with electric bolt"
              />
              <h3>
                Retail <br />
                Proximity
              </h3>
            </div>
            <div class="card">
              <img
                loading="lazy"
                src="@/assets/images/RealEstate/electric-pin.svg?external"
                alt="icon displaying electric bolt inside pin"
              />
              <h3>
                Parking <br />
                Spaces
              </h3>
            </div>
            <div class="card">
              <img
                loading="lazy"
                src="@/assets/images/RealEstate/electric-plug.svg?external"
                alt="icon displaying outlet plug with electric bolt"
              />
              <h3>
                Power <br />
                Proximity
              </h3>
            </div>
          </section>
        </div>
        <div class="lede">
          <div class="column image">
            <img
              loading="lazy"
              alt="Electrify America charging stations being installed"
              src="@/assets/images/RealEstate/construction.png"
            />
          </div>
          <div class="column">
            <h2>
              Installation and Maintenance <br />
              Costs
            </h2>
            <p>
              <strong>Electrify America pays 100% of the upfront capital investment</strong>
              for the design and installation of new charging stations, as well as maintenance and upkeep
              costs&mdash;and we're just a phone call away after contracts are signed and hardware is installed.
            </p>
          </div>
        </div>
        <div class="lede lede--reverse">
          <div class="column image map">
            <img
              v-if="!isMobile"
              loading="lazy"
              alt="Map displaying charger locations around the United States"
              src="@/assets/images/RealEstate/chargers-map.png"
            />
            <img
              v-else
              loading="lazy"
              alt="Map displaying charger locations around the United States"
              src="@/assets/images/RealEstate/chargers-map-mobile.png"
            />
          </div>
          <div class="column">
            <h2>Electrify America Electric Vehicle Charging Stations</h2>
            <p>
              Electrify America is the largest open Hyper-Fast charging network in the U.S. — with speeds up to 350 kW.
            </p>
          </div>
        </div>
      </div>
    </section>
    <form name="real-estate-form" id="real-estate-form" @submit.prevent="validate" ref="form">
      <section>
        <h2>Interested in hosting a Hyper-Fast charging station as part of the Electrify America family?</h2>
        <p>Let's get to work. Fill out the following form to contact us and start the conversation.</p>
      </section>
      <div class="form-wrap">
        <div class="tip">
          <div class="icon-container">
            <img loading="lazy" src="../../assets/images/WhatToExpect/icon-star.png" alt="Tip" />
          </div>
          <div>
            <p>
              We are seeking Site Hosts that can build Hyper-Fast charging stations with 10 or more chargers. If this
              sounds like your organization, please fill out this form.
            </p>
          </div>
        </div>
        <p aria-hidden="true" class="form-legend">An asterisk (<span>*</span>) indicates a required field</p>
        <div class="input-field">
          <label ref="firstname" for="first_name"
            >First Name <span class="require-mark" aria-hidden="true">*</span></label
          >
          <input
            id="first_name"
            maxlength="39"
            name="first_name"
            v-model="firstName"
            pattern="^[A-Za-z '\-\.]+$"
            title="This field only accepts letters and limited special characters"
            type="text"
            required
          />
        </div>
        <div class="input-field">
          <label ref="lastname" for="last_name">Last Name <span class="require-mark" aria-hidden="true">*</span></label>
          <input
            id="last_name"
            maxlength="39"
            name="last_name"
            type="text"
            pattern="^[A-Za-z '\-\.]+$"
            title="This field only accepts letters and limited special characters"
            v-model="lastName"
            required
          />
        </div>
        <div class="input-field">
          <label ref="email" for="email">Business Email <span class="require-mark" aria-hidden="true">*</span></label>
          <input
            id="email"
            maxlength="80"
            name="email"
            type="text"
            v-model="email"
            pattern="^[^\\]+@[^\\]+\.[^\\]+$"
            title="Please enter a correct email address"
            required
          />
        </div>
        <div class="input-field">
          <label for="phone">Phone Number <span class="require-mark" aria-hidden="true">*</span></label>
          <input
            id="phone"
            maxlength="10"
            name="phone"
            v-model="phone"
            type="text"
            pattern="^\d+$"
            title="This field only accepts numbers"
            required
          />
        </div>
        <div class="input-field">
          <label ref="companyname" for="company_name"
            >Company Name <span class="require-mark" aria-hidden="true">*</span></label
          >
          <input
            id="company_name"
            maxlength="200"
            name="company_name"
            type="text"
            pattern="^[^\\]+$"
            v-model="company"
            required
          />
        </div>
        <div class="input-field">
          <label for="job_title">Job Title<span class="require-mark" aria-hidden="true">*</span></label>
          <input
            id="job_title"
            maxlength="200"
            name="job_title"
            type="text"
            pattern="^[^\\]+$"
            v-model="jobTitle"
            required
          />
        </div>
        <div class="input-field">
          <label for="company_role"
            >Job Seniority<span class="require-mark" aria-hidden="true">*</span>
            <select id="company_role" name="company_role" v-model="companyRole" required>
              <option v-for="(item, index) in companyRoleOptions" :value="item" :key="index">{{ item }}</option>
            </select>
          </label>
        </div>

        <div class="input-field">
          <label for="property_relationship"
            >Relationship to Property <span class="require-mark" aria-hidden="true">*</span></label
          >
          <select v-model="propertyRelationship" name="property_relationship" id="property_relationship" required>
            <option v-for="(item, index) in propertyRelationshipOptions" :value="item" :key="index">{{ item }}</option>
          </select>
        </div>

        <div class="input-field">
          <label for="like_to">I am interested in <span class="require-mark" aria-hidden="true">*</span></label>
          <select v-model="interestType" name="like_to" id="like_to" required>
            <option v-for="(item, index) in interestTypeOptions" :value="item" :key="index">{{ item }}</option>
          </select>
        </div>

        <div class="input-field">
          <label for="num_properties"
            >How many properties do you want to add charging to?<span class="require-mark" aria-hidden="true"
              >*</span
            ></label
          >
          <select v-model="numberProperties" name="num_properties" id="num_properties" required>
            <option v-for="(item, index) in numberPropertiesOptions" :value="item" :key="index">{{ item }}</option>
          </select>
        </div>

        <div class="input-field">
          <label for="property_type"
            >What type of properties do you want to add EV charging to?
            <span class="require-mark" aria-hidden="true">*</span>
          </label>
          <select v-model="propertyType" name="property_type" id="property_type" required>
            <option v-for="(item, index) in propertyTypeOptions" :value="item" :key="index">{{ item }}</option>
          </select>
        </div>

        <div v-if="requireOtherPropertyType" class="input-field">
          <p id="prompt-for-other-property" class="prompt-for-details">
            Please elaborate on what other types of properties you would like to add charging to.
          </p>
          <label for="other_property_type"
            >Other property type<span class="require-mark" aria-hidden="true">*</span></label
          >
          <input
            id="other_property_type"
            maxlength="200"
            name="other_property_type"
            type="text"
            pattern="^[^\\]+$"
            v-model="otherPropertyType"
            required
          />
        </div>

        <div class="input-field">
          <label for="multi_states"
            >What states are your properties located in?<span class="require-mark" aria-hidden="true">*</span>
            <div id="multi_states" v-for="(item, index) in StatesList" :value="item" :key="`multiple_state_${index}`">
              <input type="checkbox" :value="item.name" v-model="multistate" :id="`multiple_state_${item.name}`" />
              <label :for="`multiple_state_${item.name}`">{{ item.name }}</label>
            </div>
          </label>
        </div>

        <div class="input-field">
          <label for="desired_count"
            >How many parking spaces do you have in your parking lots?
            <span class="require-mark" aria-hidden="true">*</span></label
          >
          <select v-model="parkingSpaceAvailability" name="desired_count" id="desired_count" required>
            <option v-for="(item, index) in parkingSpaceAvailabilityOptions" :value="item" :key="index">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="input-field">
          <label for="address"
            >Desired Charging Station Address<span class="require-mark" aria-hidden="true">*</span>
            <reference-link :num="1">
              We would love to know more about your property locations. Please include your property address details
              that you would like to start hosting charging stations at.
            </reference-link>
            <span class="residential-note"
              ><strong>Note: </strong> We do not accept residential home locations through this form.</span
            ></label
          >
          <input id="address" v-model="street" name="address" type="text" required />
        </div>
        <div class="input-field">
          <label for="city">City <span class="require-mark" aria-hidden="true">*</span></label>
          <input id="city" v-model="city" name="city" type="text" required />
        </div>
        <div class="input-field">
          <label for="state_code"
            >State<span class="require-mark" aria-hidden="true">*</span>
            <select id="state_code" name="state_code" v-model="state" required>
              <option value="" selected hidden>Select a State</option>
              <option v-for="item in StatesList" :value="item.name" :key="item.abbreviation">
                {{ item.name }}
              </option>
            </select>
          </label>
        </div>
        <div class="input-field">
          <label for="zipCode">Zip Code<span class="require-mark" aria-hidden="true">*</span></label>
          <input
            id="zipCode"
            maxlength="10"
            name="zipCode"
            v-model="zipCode"
            type="text"
            pattern="^[a-zA-Z0-9\s]+(?:[a-zA-Z0-9\-\s])+(?:[a-zA-Z0-9\s])$"
            title="This field accepts numbers, letters, and some special characters"
            required
          />
        </div>

        <div class="input-field">
          <label for="parking_space_types"
            >What type of parking lot access do you offer?
            <span class="require-mark" aria-hidden="true">*</span>
          </label>
          <div v-for="(item, index) in parkingSpaceTypesOptions" :value="item" :key="`parking_types_${index}`">
            <input type="checkbox" :value="item" v-model="parkingSpaceTypes" :id="`parking_types_${item}`" />
            <label :for="`parking_types_${item}`">{{ item }}</label>
          </div>
        </div>
        <div v-if="requireOtherParkingSpaceTypes" class="input-field">
          <p id="prompt-for-other-parking" class="prompt-for-details">
            Please elaborate on what other parking space types are available.
          </p>
          <label for="other_parking_type"
            >Other Parking Type<span class="require-mark" aria-hidden="true">*</span></label
          >
          <input
            id="other_parking_type"
            maxlength="200"
            name="other_parking_type"
            type="text"
            pattern="^[^\\]+$"
            v-model="otherParkingSpaceTypes"
            required
          />
        </div>
        <div class="input-field">
          <label for="notes">Additional Property Notes</label>
          <textarea v-model="notes" maxlength="1000" id="notes" name="notes"></textarea>
        </div>
        <div class="input-field checkbox">
          <label for="further-communication" class="checkbox">
            <input
              v-model="OptMeinFutureComm"
              id="further-communication"
              name="further-communication"
              type="checkbox"
              value="true"
            />
            I agree to receive further information from Electrify America*
          </label>
          <p class="form-question">*I am aware that I may unsubscribe to electronic communication at any time.</p>
          <p class="form-question">
            Click <router-link class="link" :to="{ name: 'privacy-en' }" target="_blank">here</router-link> for
            Electrify America's Privacy Statement.
          </p>
        </div>
        <input ref="submitButton" class="button button--submit" name="submit" type="submit" value="SUBMIT" />
        <p class="references">
          <sup>1</sup>https://www.eei.org/resourcesandmedia/energytalk/Pages/Issue-In-Depth-11-1-2018.html
        </p>
        <p class="references">
          <sup>2</sup>https://www.linkedin.com/pulse/do-ev-charging-stations-make-more-loyal-customers-survey-leavitt/
        </p>
      </div>
      <p v-show="serverError !== ''" class="server-error">
        Error:
        <br />
        {{ serverError }}
      </p>
    </form>
  </div>
</template>

<script>
import States from '@/assets/json/us_states_and_dc.json';
import ApiService from '@/services/Api';
import ReferenceLink from '@/components/ReferenceLink/ReferenceLink.vue';

export default {
  name: 'real-estate',
  components: { ReferenceLink },
  metaInfo: {
    title: 'Host an EV Charging Station | Electrify America',
    meta: [
      {
        name: 'description',
        content:
          'Become an Electrify America site host and bring Hyper-Fast EV charging to your property at no upfront cost. Attract new customers and grow revenue.',
      },
    ],
    link: [{ rel: 'canonical', href: 'https://www.electrifyamerica.com/real-estate/' }],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          url: 'https://www.electrifyamerica.com/real-estate/',
          name: 'Become an Electrify America Site Host',
          isPartOf: { '@id': 'https://www.electrifyamerica.com/#website' },
        },
      },
    ],
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      company: null,
      phone: null,
      city: null,
      street: null,
      multistate: [],
      state: '',
      StatesList: States,
      zipCode: null,
      jobTitle: null,
      companyRole: null,
      companyRoleOptions: ['Intern', 'Associate', 'Manager', 'Sr. Manager', 'Director', 'Executive', 'Founder/Owner'],
      interestType: '',
      interestTypeOptions: [
        'Hosting Charging Stations',
        'Owning a Charging Network',
        'Both Owning and Hosting Charging Stations',
      ],
      numberProperties: '',
      numberPropertiesOptions: ['1-10 Properties', '11-20 Properties', '21-30 Properties', '31+ Properties'],
      propertyType: '',
      propertyTypeOptions: [
        'Quick Service Restaurant',
        'Grocery Store',
        'Retail/Department Store',
        'Mall/Shopping Center',
        'Food and Beverage',
        'Entertainment & Large Venue',
        'Lifestyle Center',
        'Cafe/Coffeeshop',
        'Other',
      ],
      otherPropertyType: '',
      parkingSpaceAvailability: '',
      parkingSpaceAvailabilityOptions: ['1-50 Parking Spaces', '51-99 Parking Spaces', '100+ Parking Spaces'],
      parkingSpaceTypes: [],
      parkingSpaceTypesOptions: [
        'Gated Parking Lots',
        'Customers Pay for Parking',
        '24/7 Customer Accessibility',
        'Other',
      ],
      otherParkingSpaceTypes: '',
      propertyRelationship: null,
      propertyRelationshipOptions: ['Own', 'Lease', 'Manage', 'Broker'],
      timelineOptions: ['As soon as possible', '6 - 12 months', '12-24 months', 'No Preference'],
      notes: null,
      OptMeinFutureComm: null,
      serverError: '',
    };
  },
  computed: {
    isTablet() {
      return this.$resize && this.$mq.below(1200);
    },
    requireOtherPropertyType() {
      return this.propertyType === 'Other';
    },
    requireOtherParkingSpaceTypes() {
      return this.parkingSpaceTypes.includes('Other');
    },
    isMobile() {
      return this.$resize && this.$mq.below(950);
    },
  },
  methods: {
    async validate(e) {
      e.preventDefault();
      // We need to manually enforce these, since they are situational on if they are required
      if (this.requireOtherParkingSpaceTypes && this.otherParkingSpaceTypes === '') {
        const element = document.getElementById('prompt-for-other-parking');
        if (element) {
          element.scrollIntoView();
        }
        return;
      }
      if (this.requireOtherPropertyType && this.otherPropertyType === '') {
        const element = document.getElementById('prompt-for-other-property');
        if (element) {
          element.scrollIntoView();
        }
        return;
      }

      this.$refs.submitButton.disabled = true;
      this.serverError = '';
      try {
        const params = {
          site: 'ELAM',
          recaptchaToken: await this.recaptcha(),
          body: {
            FirstName: this.firstName,
            LastName: this.lastName,
            Email: this.email,
            Phone: this.phone,
            CompanyName: this.company,
            City: this.city,
            Street: this.street,
            State: this.state,
            MultiState: this.multistate,
            Zipcode: this.zipCode,
            JobTitle: this.jobTitle,
            CompanyRole: this.companyRole, // Job seniority
            InterestType: this.interestType,
            NumberOfProperties: this.numberProperties,
            PropertyType: this.propertyType,
            OtherPropertyType: this.otherPropertyType,
            ParkingSpaceAvailability: this.parkingSpaceAvailability,
            ParkingLotType: this.parkingSpaceTypes,
            OtherParkingLotType: this.otherParkingSpaceTypes,
            PropertyRelationship: this.propertyRelationship,
            Notes: this.notes, // Additional Property Notes
            OptMeinFutureComm: this.OptMeinFutureComm,
            utm_source: this.$route.query.utm_source,
            utm_medium: this.$route.query.utm_medium,
            utm_campaign: this.$route.query.utm_campaign,
            utm_term: this.$route.query.utm_term,
            utm_content: this.$route.query.utm_content,
          },
        };
        this.realEstatePut(params);
      } catch (error) {
        console.error(error);
        this.$refs.submitButton.disabled = false;
        this.$gtm.trackEvent({
          event: 'interaction',
          category: 'form_failed',
          action: 'submit',
          form_id: 'real-estate-form',
          form_name: 'real-estate-form',
          label: 'Submission failed (network error)',
        });
      }
    },

    realEstatePut(params) {
      const loader = this.$loading.show();
      this.$store.commit('setEmail', this.email);
      ApiService.init();
      ApiService.put('/v1/salesforce/sitehostcontactus', params)
        .then((res) => {
          if (res.status === 'success') {
            this.$router.push({ name: 'email-verification-en' });
          } else {
            this.serverError = res.errorMsg;
          }
          loader.hide();
          this.$refs.submitButton.disabled = false;
        })
        .catch((error) => {
          // Commenting out surfacing Salesforce errors to end users until we've made messaging more robust
          /*
          if (error.response.status === 500) {
            this.serverError = 'There was an error submitting the form, please try again';
          } else {
            this.serverError = error.response.data.errMsg;
          }
          */
          this.serverError = 'There was an error submitting the form, please try again';

          this.$refs.submitButton.disabled = false;
          loader.hide();
          console.error(error);
        });
    },
    async recaptcha() {
      try {
        // Wait for recaptcha loading
        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login" and return the token
        return await this.$recaptcha('login');
      } catch (e) {
        throw new Error('recaptcha login failed');
      }
    },
  },
  mounted() {
    this.$recaptchaLoaded().then(() => {
      this.$recaptchaInstance.showBadge();
    });
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
};
</script>

<style lang="scss" scoped>
.real-estate {
  img {
    width: 100%;
    height: 100%;
  }

  .container {
    overflow: auto;
    padding: 0 20px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    @media (max-width: 900px) {
      flex-direction: column;
    }
  }

  .hero {
    background: url('~@/assets/images/RealEstate/realestate-hero.png') no-repeat;
    background-size: auto;
    background-position-x: center;
    height: 696px;
    color: $c-primary-background;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 64px;

    @media (max-width: 900px) {
      padding-left: 20px;
      padding-right: 20px;
      min-height: 700px;
    }

    h1 {
      font-size: 64px;
      font-weight: 200;
      line-height: 0.92;
      margin: 0;
      @media (max-width: 900px) {
        font-size: 48px;
      }
    }
    h1 + p {
      font-size: 2rem;
      font-weight: $fw-regular;
      line-height: 38px;
      margin-top: 9px;
      max-width: 590px;

      @media (max-width: 900px) {
        font-size: 18px;
        max-width: 320px;
      }
    }

    h1,
    p {
      text-shadow: 0px 0px 6px black, 0px 0px 12px black;
      color: $c-primary-background;
    }

    .button {
      font-size: 1rem;
      background: linear-gradient(90deg, rgba(53, 189, 209, 1) 50%, rgba(255, 255, 255, 1) 50%);
      color: $c-primary;
      border: none;
      background-position: 100% 0;
      background-size: 202% auto;
      transition: all 300ms ease;
      margin-top: 20px;
      padding: 21px 45px;
      &:hover,
      &:active {
        background-position: 0 0;
      }
      @media (max-width: 450px) {
        margin-top: 0px;
      }
    }
    .flex {
      padding-top: 100px;
      text-align: center;
      justify-content: flex-end;

      p {
        margin: 0 30px;
        max-width: 230px;
        font-weight: $fw-regular;
      }
      @media (max-width: 900px) {
        padding-bottom: 100px;
        padding-top: 100px;

        p {
          margin: 10px 0;
          max-width: 600px;
        }
      }
      @media (max-width: 450px) {
        padding-bottom: 50px;
        padding-top: 50px;
      }
    }
  }

  .body {
    margin: -60px 0 0 0;
    padding: 0;
    background-color: $c-primary-background;
  }
  .cards-container {
    text-align: center;
    max-width: 988px;
    margin: 0 auto;
    margin-bottom: 120px;
    h2 {
      margin: 0.83em 0;
    }
  }
  .card {
    background-color: $c-secondary-background;
    width: 307px;
    margin-right: 30px;
    border-radius: 8px;
    text-align: left;
    padding: 60px 0 40px 40px;
    img {
      height: auto;
      width: auto;
      padding-bottom: 40px;
    }
    h3 {
      border-top: 3px solid #35bdd1;
      padding-top: 20px;
      max-width: 180px;
      font-size: 25px;
      font-weight: 600;
    }
    &:last-child {
      margin-right: 0;
    }
    @media (max-width: 1030px) {
      margin: 30px auto;

      &:last-child {
        margin-right: auto;
      }
    }
  }

  .lede {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &:first-of-type {
      margin-bottom: 100px;
    }
    &:last-of-type {
      margin-bottom: 100px;
    }
    a {
      text-decoration: underline;
      font-weight: $fw-medium;
      cursor: pointer;
    }

    h2 {
      max-width: 370px;
      letter-spacing: 0.02em;
      margin-bottom: 1rem;
      padding: 25px 0 35px 0;
      &::after {
        content: '';
        width: 84px;
        border-top: 4px solid #35bdd1;
        display: block;
        border-radius: 5px;
        position: relative;
        top: 34px;
        @media (max-width: 950px) {
          top: 23px;
        }
      }
    }

    p {
      margin: 0;
      margin-bottom: 28px;
      width: 70%;
    }
    ul {
      padding: 0;
    }

    .list-electric-charger {
      li {
        list-style: none;
        background: url('~@/assets/images/RealEstate/electric-icon.svg?external') no-repeat;
        padding-left: 30px;
        line-height: 24px;
        margin: 10px 0;
        width: 70%;
      }
    }

    .column {
      display: flex;
      flex-direction: column;
      position: relative;
      padding-left: 5%;
      width: calc(30%);
      justify-content: center;
      &.image {
        width: calc(70%);
        padding: 0;
        align-items: flex-start;
      }
      &.map {
        img {
          width: 95%;
          @media screen and (min-width: 950px) {
            width: 80%;
          }
        }
        align-items: center;
        text-align: center;
        position: relative;
      }
    }

    &--reverse {
      flex-direction: row-reverse;
    }

    @media screen and (max-width: 950px) {
      align-items: center;
      flex-direction: column;
      margin-bottom: 100px;

      .column {
        width: calc(100vw - 30px);
        align-items: center;
        justify-content: center;
        padding-left: 0;

        p {
          width: calc(100vw - 30px);
          max-width: 400px;
        }
        h2 {
          margin: 0;
          padding-top: 35px;
          max-width: 400px;
          width: calc(100vw - 30px);
          &.short-title {
            width: calc(100vw - 30px);
          }
        }
        &.image {
          width: 100%;
        }
        ul {
          max-width: 400px;
        }
      }
    }
  }

  form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    h2 {
      max-width: 376px;
      padding-bottom: 59px;
      margin-top: 0;
    }

    section {
      width: 40%;
      max-width: 400px;
      margin-left: 100px;
      @media (max-width: 1200px) {
        margin-left: 0;
      }
      p {
        &::before {
          content: '';
          width: 84px;
          border-top: 4px solid #35bdd1;
          display: block;
          border-radius: 5px;
          position: relative;
          bottom: 10px;
        }
      }
    }
    .form-wrap {
      width: 60%;
      padding-bottom: 80px;
      padding-top: 22px;
      margin-left: 100px;
      @media (max-width: 1200px) {
        margin-left: 0;
      }
    }

    .form-question {
      color: $c-text;
      font-weight: normal;
      font-size: 16px;
      span {
        font-size: 16px;
      }
    }
    p.form-question:first-of-type {
      margin-top: 16px;
    }

    h2,
    p {
      color: $c-primary;
    }

    .input-field {
      margin-bottom: 29px;
      position: relative;
      .multistate {
        height: 250px;
      }
    }

    .prompt-for-details {
      width: 600px;
      max-width: 710px;
      margin-top: 0px;

      @media (max-width: 950px) {
        width: calc(100vw - 50px);
      }
    }

    input,
    textarea,
    select {
      transition: 500ms ease;
      box-sizing: border-box;
      width: 600px;

      @media (max-width: 950px) {
        width: calc(100vw - 50px);
      }
    }

    input[type='submit'] {
      width: 150px;
      margin-bottom: 50px;
    }

    input[type='checkbox'] {
      width: 16px;
      height: 16px;
      margin-bottom: 10px;
    }

    .references {
      font-size: 10px;
      margin: 4px 0;
      letter-spacing: 1.61;
      sup {
        font-size: 6px;
      }
    }
    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 0px;
      .form-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(100vw - 50px);
      }
      section {
        max-width: 100%;
        width: calc(100vw - 30px);
        display: flex;
        flex-direction: column;
        align-items: center;
        h2 {
          max-width: 600px;
          margin: 0;
        }
        p {
          text-align: left;
        }
      }
    }
  }
  .tip {
    @media (max-width: 1200px) {
      max-width: 800px;
    }
    max-width: 600px;
    margin-top: 20px;

    display: flex;
    flex-direction: row;
    .icon-container {
      display: flex;
      img {
        align-self: center;
        width: 20px !important;
        height: 20px;
      }
    }
    p {
      font-weight: 500;
      margin: 0;
      margin-left: 15px;
      margin-bottom: 15px;
    }
  }

  .residential-note {
    padding-left: 5px;
    color: #0b0f4d;
  }
}
</style>
